import { FormControl, FormLabel, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import Select from 'react-select';

interface CommonProps {
  disabled?: boolean;
  title: string;
  isRequiredFalse?: boolean;
  options: any[];
  onSelect: (name: string, selectedIds: string[]) => void;
  selectedIds?: string[];
  name: string;
  placeholder?: string;
}

const ReactMultiSelect: React.FC<CommonProps> = ({
  title,
  isRequiredFalse = false,
  onSelect,
  options,
  name,
  selectedIds = [],
  placeholder,
}) => {
  const [selectedOptions, setSelectedOptions] = React.useState<
    { value: string; label: string }[]
  >([]);

  const textColor = useColorModeValue('navy.700', 'white');
  const formattedOptions = options.map((country: any) => ({
    value: country._id,
    label: country.name,
  }));
  React.useEffect(() => {
    const initialSelected = formattedOptions.filter((option) =>
      selectedIds.includes(option.value),
    );
    setSelectedOptions(initialSelected);
  }, []);
  const handleChange = (selectedOptions: any) => {
    const ids = selectedOptions
      ? selectedOptions.map((option: { value: string }) => option.value)
      : [];
    setSelectedOptions(selectedOptions || []);
    onSelect(name, ids);
  };
  return (
    <FormControl isRequired={isRequiredFalse}>
      <FormLabel
        display="flex"
        ms="4px"
        fontSize="sm"
        fontWeight="500"
        color={textColor}
        mb="8px"
      >
        {title}
      </FormLabel>
      <Select
        isMulti
        value={selectedOptions}
        options={formattedOptions}
        onChange={handleChange}
        placeholder={placeholder}
        className="basic-multi-select"
        classNamePrefix="select"
      />
    </FormControl>
  );
};

export default ReactMultiSelect;
